import { render, staticRenderFns } from "./TextAndAudioView.vue?vue&type=template&id=788a37eb&scoped=true"
import script from "./TextAndAudioView.vue?vue&type=script&lang=js"
export * from "./TextAndAudioView.vue?vue&type=script&lang=js"
import style0 from "./TextAndAudioView.vue?vue&type=style&index=0&id=788a37eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a37eb",
  null
  
)

export default component.exports